import React from "react";

import { Button } from "../../../Button";

export const UserVoteButtons = ({ onCancel, disabled, isValid }) => {
  return (
    <div className="container margin-top-20 margin-bottom-20">
      <div className="row row--justify-space">
        <Button
          type="button"
          onClick={() => {
            onCancel();
          }}
        >
          Powrót
        </Button>
        <Button type="submit" disabled={disabled || !isValid}>
          Zapisz
        </Button>
      </div>
    </div>
  );
};
